'use client';

import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const TRACK_URL = `https://${process.env.NEXT_PUBLIC_REST_ENDPOINT}/widgets/track/`;

function getParentReferrer(): string | undefined {
  if (document.referrer) return document.referrer;
  try {
    return window.location.ancestorOrigins?.[0];
  } catch {
    return undefined;
  }
}

export const useTrackWidgetUsage = () => {
  const { query } = useRouter();
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current) {
      return;
    }

    hasTrackedRef.current = true;

    const referrer = getParentReferrer();
    if (!referrer) {
      return;
    }

    let hostname: string;
    try {
      hostname = new URL(referrer).hostname;
    } catch {
      return;
    }

    if (hostname.includes('scorenco.com') || query.oldWidgetId) {
      return;
    }

    const widgetId = Number([query.widgetId].flat()[0]);

    fetch(TRACK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        domain_name: hostname,
        url: referrer,
        ...(!Number.isNaN(widgetId) && { widget_id: widgetId }),
      }),
      keepalive: true,
      mode: 'cors',
    }).catch(() => undefined);
  }, [query]);
};
